import { createAction, handleActions } from 'redux-actions';

const setPagination = createAction("SCREENS/SUPPLIERS/SET_PAGINATION");

const defaultState = {
  current: 1,
  pageSize: 15,
  total: 0
};

const reducer = handleActions(
  {
    [setPagination]: (state, action) => ({ ...state, ...action.payload })
  },
  defaultState
);

export { setPagination, reducer };
